import React from 'react'
import { Route, Routes } from 'react-router'
import {
  adminRoutes,
  authRoutes,
  publicRoutes,
  userRoutes,
} from './router.link'
import Feature from '../feature'
import AuthFeature from '../authFeature'
import ProtectedRoute from './protectedRoute'
import Error404 from '../auth/error/error-404/error400'
import GuestRoute from './guestRoute'
import { DevNavigation } from '../dev'

const ALLRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<GuestRoute />}>
          <Route element={<AuthFeature />}>
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>

        <Route element={<ProtectedRoute roles={['admin', 'supervisor']} />}>
          <Route element={<Feature />}>
            {adminRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>

        <Route element={<ProtectedRoute roles={['user']} />}>
          <Route element={<Feature />}>
            {userRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>

        <Route path="*" element={<Error404 />} />
      </Routes>

      {/* Development Navigation - Only visible in development mode */}
      <DevNavigation />
    </>
  )
}

export default ALLRoutes
